import React from "react";
import { Zap, Bot, ArrowRight } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative border-b border-[#262626] overflow-hidden"
    >
      {/* Background grid pattern */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.07] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(#FFD700 1px, transparent 1px), linear-gradient(90deg, #FFD700 1px, transparent 1px)",
          backgroundSize: "80px 80px",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7 fade-up">
          <div className="inline-flex items-center gap-2 border border-[#FFD700] px-3 py-1 mb-6">
            <span className="w-2 h-2 bg-[#FFD700] animate-pulse" />
            <span className="font-mono text-xs uppercase tracking-widest text-[#FFD700]">
              0-24 Hibaelhárítás · Országos kiszállás · 200-300 km
            </span>
          </div>

          <h1 className="font-heading uppercase text-5xl md:text-7xl lg:text-8xl leading-[0.9] flicker">
            Brutálisan jó<br />
            <span className="text-[#FFD700]">villany&shy;szerelés.</span>
          </h1>

          <p className="mt-6 max-w-xl text-lg md:text-xl text-[#A3A3A3] leading-relaxed">
            Lakás, családi ház, ipari létesítmény. Hibajavítás, kivitelezés, okosotthon.
            <span className="text-white font-bold"> Minden, ami villany.</span> Magyar mesterek,
            valós áron — most már <span className="text-[#FFD700] font-bold">AI segítséggel</span>.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <a href="#kapcsolat" data-testid="hero-cta-primary" className="btn-primary">
              <Zap className="w-5 h-5" /> Azonnali segítség
              <ArrowRight className="w-4 h-4" />
            </a>
            <a href="#ai" data-testid="hero-cta-ai" className="btn-ghost">
              <Bot className="w-5 h-5" /> AI Árkalkulátor
            </a>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-4 max-w-lg font-mono text-xs">
            <div className="border-l-2 border-[#FFD700] pl-3">
              <div className="text-[#FFD700] text-2xl font-heading">0-24</div>
              <div className="text-[#A3A3A3] uppercase">ügyelet</div>
            </div>
            <div className="border-l-2 border-[#FFD700] pl-3">
              <div className="text-[#FFD700] text-2xl font-heading">AI</div>
              <div className="text-[#A3A3A3] uppercase">diagnózis</div>
            </div>
            <div className="border-l-2 border-[#FFD700] pl-3">
              <div className="text-[#FFD700] text-2xl font-heading">100%</div>
              <div className="text-[#A3A3A3] uppercase">garancia</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-5 relative fade-up">
          <div className="relative">
            <img
              src="https://images.pexels.com/photos/33531830/pexels-photo-33531830.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Villanyszerelő munka közben"
              className="w-full h-[420px] md:h-[520px] object-cover grayscale contrast-125 border-2 border-[#262626]"
            />
            <div
              aria-hidden
              className="absolute inset-0 bg-gradient-to-br from-transparent via-black/30 to-[#FFD700]/10"
            />
            {/* Sticker */}
            <div className="absolute -bottom-5 -left-5 bg-[#FFD700] text-black px-4 py-3 font-heading uppercase tracking-tight border-2 border-black shadow-[6px_6px_0_0_#000]">
              <div className="text-xs">CÉGJEGYZÉK</div>
              <div className="text-2xl leading-none">13-09-243381</div>
            </div>
            {/* Voltage tag */}
            <div className="absolute -top-4 -right-4 bg-black border-2 border-[#FFD700] px-4 py-2 font-mono text-[#FFD700] text-sm tracking-widest rotate-3">
              ⚡ 230V / 400V
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
